import React, { useState } from 'react';

import { useStyles } from '~/assets/styles';
import Menu from '~/components/core/Atomic/Menu';
import MenuItem from '~/components/core/Atomic/MenuItem';
import { PencilIcon } from '~/components/icons';
import InlineIconButton from '~/components/InlineIconButton';
import type { IncidentConfigurationSummary } from '~/components/SystemConfiguration/IncidentConfigurationPage/types';

interface EditFnolMenuProps {
  row: IncidentConfigurationSummary;
  onEdit: (row: IncidentConfigurationSummary) => void;
  trackMixpanelEvent: (incidentConfiguration: IncidentConfigurationSummary) => void;
  onEditFnolInbox: (row: IncidentConfigurationSummary) => void;
  onEditPostFnolHook?: (row: IncidentConfigurationSummary) => void;
  isDisplayInboxColsEnabled?: boolean;
}

const EditFnolButton: React.FC<EditFnolMenuProps> = ({
  row,
  onEdit,
  trackMixpanelEvent,
  onEditFnolInbox,
  onEditPostFnolHook,
  isDisplayInboxColsEnabled,
}) => {
  const { classes } = useStyles();

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const hasExtraMenuItems = (row.fnol_email_inbox_name && isDisplayInboxColsEnabled) || onEditPostFnolHook;

  const handleEditIconClick = (event: React.MouseEvent<HTMLElement>) => {
    if (hasExtraMenuItems) {
      setAnchorEl(event.currentTarget as HTMLElement);
    } else {
      onEdit(row);
      trackMixpanelEvent(row);
    }
  };

  return (
    <div>
      <InlineIconButton
        icon={PencilIcon}
        tooltipTitle="Edit"
        className={`${classes.textIcon} ${classes.marginedIcon} ${classes.hoverableNonFilledIcon}`}
        onClick={(e: React.MouseEvent<HTMLElement>) => handleEditIconClick(e)}
      />
      <Menu id="simple-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        <MenuItem
          onClick={() => {
            onEdit(row);
            trackMixpanelEvent(row);
            setAnchorEl(null);
          }}
        >
          Edit FNOL Form
        </MenuItem>
        {row.fnol_email_inbox_name && isDisplayInboxColsEnabled && (
          <MenuItem
            className="flex flex-row gap-4"
            onClick={() => {
              onEditFnolInbox(row);
              setAnchorEl(null);
            }}
          >
            Edit Inbox
          </MenuItem>
        )}
        {onEditPostFnolHook && (
          <MenuItem
            onClick={() => {
              onEditPostFnolHook(row);
              setAnchorEl(null);
            }}
          >
            Post-FNOL Hook
          </MenuItem>
        )}
      </Menu>
    </div>
  );
};

export default EditFnolButton;
